/**
* 专利查新报告分析结果对话框组件
*
* 主要组件：
* - 左侧面板：PDF预览和分析建议
* - 右侧面板：专利详细信息表单
*/
<template>
  <el-drawer v-model="dialogVisible" direction="btt" :width="'100vw'" :modal="true" :append-to-body="true"
    :close-on-click-modal="false" class="analysis-dialog" destroy-on-close @closed="handleCloseDialog">
    <template #header="{ titleId, titleClass }">
      <h4 :id="titleId" :class="titleClass" style="line-height: 40px;">
        <el-icon @click="handleBack" v-if="isComparing">
          <Back />
        </el-icon>
        查新对比
        <span>
          <el-select v-show="isShowCompare && authPermission(['feature'])" @change="handleTypeChange" v-model="typeValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="item in typechooser" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </span>
      </h4>
    </template>
    <div class="analysis-content">
      <div class="selectshow" @click="isShowCompare = !isShowCompare"></div>
      <!-- 左侧面板 -->
      <div class="left-panel" v-if="isComparing && isFeatureSuccess">
        <!-- PDF 预览区域 -->
        <div class="preview-section">
          <!-- <h3>{{analysisResult.filename || '新颖性报告'}}</h3> -->
          <div class="pdf-container">
            <div class="pdf-content">
              <vue-pdf-embed :source="pdfSource" :page="currentPage" @rendered="handlePageRendered"
                @loading="handleLoading" @error="handleError" :style="{ width: '100%', height: '100%' }" />
            </div>
            <div class="pdf-navigation">
              <el-button @click="prevPage" :disabled="currentPage <= 1" link>
                <el-icon :size="36"><svg-icon name="prev" /></el-icon>
              </el-button>
              <!-- <span class="page-info">{{ currentPage }} / {{ totalPages }}</span> -->
              <el-button @click="nextPage" :disabled="currentPage >= totalPages" link>
                <el-icon :size="36"><svg-icon name="next" /></el-icon>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 将分析建议移到这里 -->
        <div class="suggestions-section" ref="suggestRef" @mousedown="handleMouseDown">
          <h4>
            <el-icon :size="20"><svg-icon name="suggest" /></el-icon>
            修改建议
          </h4>
          <div class="suggestion-content">
            <div v-if="analysisText" v-html="formattedAnalysisText" class="analysis-text" ref="analysisTextRef"></div>
            <div v-else class="suggestion-header">
              <el-icon>
                <Warning />
              </el-icon>
              <span>暂无分析结果</span>
            </div>
          </div>
        </div>
      </div>
      <div class="left-process-panel" v-if=" arrowShow && !isComparing">
        <CardTitle icon="process" @click="handleOperateProcess">查新报告操作流程</CardTitle>
        <div class="process-item">
          <div class="process-title">01 生成摘要并获取查新报告</div>
          <div class="process-content">
            <ul class="abstract-tags">
              <li v-for="item in abstractTags" :key="item.value"
                :class="{ 'abstract-tag-item': true, 'abstract-tag-selected': selectedTags.includes(item.value) }"
                @click="handleSelectTag(item)">
                <el-icon v-if="selectedTags.includes(item.value)">
                  <Check />
                </el-icon>
                {{ item.label }}
              </li>
            </ul>
            <el-input type="textarea" v-model="abstractStr" :maxlength="maxAbstractLength"
              :readonly="!abstractStr || isStreaming || status == 'COMPLETED' || status == 'PROCESSING'" />
            <div class="abstract-actions">
              <el-button type="primary" plain @click="handleAbstrace" v-if="status == null"
                :loading="abstractLoading">生成摘要</el-button>
              <el-button type="primary" plain v-if="status == null && checkAuthCode == 0 && typeValue == 1"
                @click="handleNoveltys" :loading="isNoveltyLoading">一键查新</el-button>
              
              <el-button type="primary" plain v-if="status == null && (typeValue == 2 || typeValue == 3)"
                @click="handleNoveltys" :loading="isNoveltyLoading">特征提取</el-button>
              <el-button type="primary" plain v-if="status == null && typeValue == 4"
                @click="handleNoveltys" :loading="isNoveltyLoading">复制并跳转至查新系统</el-button>
              <el-button type="primary" plain :loading="status == 'PROCESSING'"
                v-if="status === 'PROCESSING'">查新中</el-button>
              <el-button type="primary" plain @click="stopquery" v-if="status == 'PROCESSING'">停止</el-button>
              <span v-if="status == 'PROCESSING'" class="novelty-tip">后台自动检索和生成报告中，大概需要4-5分钟</span>
              <el-button type="primary" plain :loading="isQueryloading" @click="handlequery"
                v-if="status == 'COMPLETED'">查新对比</el-button>
              <el-button type="primary" plain @click="handleDelete" v-if="status == 'COMPLETED'">清空查新</el-button>
              <span  v-if="status == 'COMPLETED'" class="novelty-tip">已获取查新报告，点击查新对比按钮进行分析</span>
              <span v-if="abstractStr">{{ abstractStr?.length || 0 }} | {{ maxAbstractLength }}</span>
              <el-icon v-if="!isStreaming && abstractStr" @click="handleCopyAbstrace">
                <CopyDocument />
              </el-icon>
            </div>
          </div>
        </div>
        <div class="process-item">
          <div class="process-title">02 上传查新报告进行对比</div>
          <el-upload class="process-upload" drag :disabled="uploadFileList.length > 0" :http-request="handleUploadFile"
            :show-file-list="false">
            <div class="process-upload-text">
              <h4>将文件拖到此处或点击上传</h4>
              <div>支持上传PDF、Word格式文件，文件不能超过10M<br />严禁上传包含色情、暴力、反动等相关违法信息的文件。</div>
              <div v-if="uploadFileList.length">
                <div v-for="file in uploadFileList" :key="file.uid" class="process-upload-file"
                  v-loading="file.status === 'uploading'">
                  <el-icon :size="24"><svg-icon name="doc" /></el-icon>
                  <span>{{ file.name }}</span>
                  <el-icon class="delete-icon" @click.stop="handleRemoveFile" v-if="!isAnalysisLoading"><svg-icon
                      name="close" /></el-icon>
                </div>
              </div>
              <el-button type="primary" @click.stop="handleComparing"
                :disabled="!uploadFileList.filter(v => v.status === 'done').length"
                :loading="isAnalysisLoading">开始对比</el-button>
            </div>
          </el-upload>
        </div>
      </div>
      <div class="middle-panel" v-if="!isComparing">
        <el-icon v-if="!arrowShow" @click="arrowShow = true">
          <DArrowRight />
        </el-icon>
        <el-icon v-if="arrowShow" @click="arrowShow = false">
          <DArrowLeft />
        </el-icon>
      </div>
      <!-- 右侧表单部分 -->
      <div class="right-panel" v-if="!isFeatureSuccess || isComparing ">
        <div class="form-section">
          <CardTitle icon="file">初版交底书</CardTitle>
          <div class="form-item" v-for="(item, index) in abstractTags" :key="item.value">
            <label>{{ item.label }}</label>
            <div class="textarea-wrapper">
              <HighlightTextArea :value="analysisFormData[item.value]" :highlight="getHighlight(item.value)"
                :highlightIndex="index" :rows="1" :disabled="!isComparing"
                @input="handleInputAnalysis(item.value, $event)" />
            </div>
            <div v-if="item.value === 'description' && props.formData.imageUrls && props.formData.imageUrls.length > 0"
              class="image-wrapper">
              <div v-for="(file, index) in props.formData.imageUrls" :key="index">
                <div class="image-title">{{ `图片${index + 1}` }}</div>
                <div v-if="file.content">{{ file.content }}</div>
                <el-image :key="index" :src="file.url" class="preview-image"
                  :preview-src-list="props.formData.imageUrls" fit="contain" :initial-index="index">
                  <template #placeholder>
                    <div class="image-placeholder">
                      <el-icon>
                        <Picture />
                      </el-icon>
                    </div>
                  </template>
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-panel" v-if="isFeatureSuccess && !isComparing">
        <div class="form-section" >
          <div>
            <el-steps style="max-width: 600px;margin: 30px auto;" :active="activeStep" align-center>
              <el-step title="技术特征确认" />
              <el-step title="对比专利选择" />
              <el-step title="特征比对查看" />
            </el-steps>
          </div>
          <div v-show="activeStep === 0">
            <div style="float: right;padding: 10px 0px;">
            <el-button type="default" link  @click="handleGenerate"><el-icon><RefreshLeft /></el-icon>重新生成</el-button>
          </div>
            <el-table :data="tableData" ref="multipleTableRef" row-key="id" @selection-change="handleSelectionChange"
              style="width: 100%" :border="true" v-loading="tableLoading">
              <el-table-column type="selection" :selectable="selectable" width="55" />
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="feature" label="特征内容">
                <template #default="scope">
                  <div v-if="!scope.row.status">{{ scope.row.feature }}</div>
                  <div v-else><el-input v-model="scope.row.feature" placeholder="请输入特征内容"></el-input></div>
                </template>
              </el-table-column>
              <el-table-column prop="operation" label="操作" width="180">
                <template #default="scope">
                  <el-button type="primary" link v-if="!scope.row.status"
                    @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button type="primary" link v-if="scope.row.status"
                    @click="handleSave(scope.row.id)">保存</el-button>
                  <el-button type="danger" link @click="handleFeatrueDelete(scope.row.id)">删除</el-button>
                  <el-button type="info" link v-if="scope.row.status" @click="handleCancel(scope.row.id)">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 30px 0;">
              <el-space size="medium" style="justify-content: center;">
                <el-button type="default" plain @click="handleAddFeature">添加特征</el-button>
                <el-button type="default" plain @click="cancel">取消</el-button>
                <el-button type="primary" plain @click="handleRetrievePatents(0)" :loading="retrieveLoading">根据所选特征进行专利检索</el-button>
              </el-space>
            </div>

          </div>
          <div v-show="activeStep === 1">
            <div style="float: right;padding: 10px 0px;">
              <el-button type="default" link  @click="handleRetrievePatents(1)"><el-icon><ZoomIn /></el-icon>查看更多专利</el-button>
               <el-button type="default" link  @click="compareDialogVisible = true"><el-icon><Plus /></el-icon>新增对比专利</el-button>
            </div>
            <el-table :data="featureList" ref="featureTableRef" :preserve-expanded-content="preserveExpanded" row-key="index" style="width: 100%;height:calc(100vh - 380px);" @selection-change="handleSecondChange" :border="true">
              <el-table-column type="expand">
                <template #default="props">
                  <div style="padding: 0px 30px;">
                    {{ props.row.abstract }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column type="selection" :selectable="selectable" width="55" />
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="p" label="公开号" width="150">
                <template #default="scope">
                <el-button type="primary" link @click="handleClick(scope.row)">{{ scope.row.p }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="t" label="标题" />
              <el-table-column prop="a" label="申请人" width="150" />
              <el-table-column prop="ad" label="申请日期" width="150" />
              <el-table-column prop="l.key" label="国际分类" width="150" />
              <el-table-column prop="r" label="相关度" width="80" >
                <template #default="scope">
                  {{ scope.row.r }}%
                </template>
              </el-table-column>
            </el-table>

             <div style="padding: 30px 0;">
              <el-space size="medium" style="justify-content: center;">
                <el-button type="default" plain @click="backStep()">上一步</el-button>
                <el-button type="primary" plain :loading="isLoading" @click="handleComparePatents">根据所选专利进行特征比对</el-button>
              </el-space>
            </div>
          </div>
          <el-dialog  v-model="compareDialogVisible"  title="专利查询" width="500" >
            <div style="padding: 10px;">
              <el-input type="textarea" v-model="featureID" :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入专利号,一行一个"></el-input>
            </div>
            <template #footer>
              <div class="dialog-footer">
                <el-button @click="compareDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmComparePatents">
                  确认
                </el-button>
              </div>
            </template>
          </el-dialog>
          <div v-show="activeStep == 2 " >
            <el-table :data="compareList" ref="compareTableRef" :preserve-expanded-content="preserveExpanded" row-key="id" style="width: 100%" :border="true">
              <el-table-column v-for="(col, index) in columns" :key="index" :prop="col.prop" :label="col.label">
              </el-table-column>
            </el-table>
            <div>
               <div class="result-title">新颖性评价：</div>
               <div class="result-content">
                 {{ novelty }}
               </div>
               <div class="result-title">创造性评价：</div>
               <div class="result-content">
                 {{ creative }}
               </div>
               <div class="result-title">结论与建议：</div>
               <div class="result-content">
                 {{ conclusion }}
               </div>

            </div>

            <div style="padding: 30px 0;">
              <el-space size="medium" style="justify-content: center;">
                  <el-button type="default" plain @click="backStep">上一步</el-button>
                  <el-button type="default" plain @click="handleExport(1)">导出</el-button>
                  <el-button type="primary" plain @click="handleExport(2)" :loading="exportLoading">查看改进建议</el-button>
              </el-space>
            </div>
          </div>


        </div>
      </div>
    </div>
    <div v-if="isComparing" class="analysis-footer">
      <el-button size="large" @click="handleClose">放弃修改</el-button>
      <el-button size="large" type="primary" @click="handleSubmit" :disabled="analysisStreaming">保存修改</el-button>
    </div>
  </el-drawer>
  <OperateProcessDialog ref="operateProcessRef" />
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, computed, nextTick, reactive } from 'vue'
import { ArrowLeft, ArrowRight, Check, CopyDocument, Back, DArrowRight, DArrowLeft,RefreshLeft,Plus,ZoomIn } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import Mark from 'mark.js'
import VuePdfEmbed from 'vue-pdf-embed'
import Clipboard from 'clipboard'
import * as pdfjsLib from 'pdfjs-dist'
import { PDFWorker } from 'pdfjs-dist'
import CardTitle from '@/components/CardTitle.vue'
import { fetchUpload, fetchDeleteFile } from '@/api/project'
import { fetchSaveCompare, forwardInvoke,fetchPatentDetail,fetchSemanticsSearch,fetchIncopatSearch,fetchPdfSearch } from '@/api/writing'
import OperateProcessDialog from './OperateProcessDialog.vue'
import HighlightTextArea from '../form/HighlightTextArea.vue'
import md5 from 'crypto-js/md5'
import { fetchReport, fetchStatus, fetchCancel, fetchClear,fetchMergedSearch } from '@/api/writing'
import { fetchAuth } from '@/api/login'
import {  featureExtraction, featureCompare } from '@/api/feature'
import { authPermission } from '@/utils/permission'
import { useRoute, useRouter } from 'vue-router'
import { fetchRecordAdd } from '@/api/project'
 const { 
  Document, Paragraph, Table, TableRow, TableCell,Packer,
  TextRun, HeadingLevel, AlignmentType 
} = require('docx');
//  import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, HeadingLevel, AlignmentType, TextDirection,IndentationType, LineSpacingType } from 'docx';
// 修改 worker 配置
onMounted(() => {
  try {
    // 使用 importScripts 方式加载
    pdfjsLib.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;

    // 添加错误处理
    if (typeof window.Worker === 'undefined') {
      console.warn('Web Workers are not supported in this environment');
      // 降级使用 fake worker
      pdfjsLib.GlobalWorkerOptions.disableWorker = true;
    }
  } catch (error) {
    console.error('PDF worker initialization failed:', error);
    // 降级使用 fake worker
    pdfjsLib.GlobalWorkerOptions.disableWorker = true;
  }
})

// 在组件卸载时清理定时器
onUnmounted(() => {
  stopStatusCheck();
})
const route = useRoute();
const router = useRouter();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object,
    required: true,
    default: () => ({
      title: '',
      inventor: '',
      field: '',
      project: '',
      background: '',
      problem: '',
      technical: '',
      effect: '',
      implementation: '',
      description: '',
      imageUrls: []
    })
  },
  projectId: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:visible', 'close', 'export', 'submit','exportFile'])

const dialogVisible = ref(false)
const currentPage = ref(1)
const totalPages = ref(1)
// 是否开始对比
const isComparing = ref(false)
const pdfSource = ref()

const pdfDocument = ref(null)
const operateProcessRef = ref()
const analysisTextRef = ref()
const abstractStr = ref('')
const isAnalysisLoading = ref(false)
const isStreaming = ref(false)
const maxAbstractLength = 500
const uploadFileList = ref([])
const analysisText = ref()
const analysisHtml = ref()
const analysisFormData = ref({})
const analysisStreaming = ref(false)
const suggestRef = ref()
const autoScroll = ref()
const abortController = ref()
const abstractLoading = ref(false)
const isNoveltyLoading = ref(false)
const isQueryloading = ref(false)
const exportLoading = ref(false)
const tableLoading = ref(false)
let analysisResult = reactive({})
// 用于保存查新生成的文件信息，不使用uploadFileList
const noveltyFileList = ref([])
// 从专利数据JSON中获取PatentList
const featureList = ref([])
// 动态列定义
const columns = ref([
  { prop: 'id', label: '技术特征标识' },
])
const novelty = ref('')
const creative = ref('')
const conclusion = ref('')
// 模拟动态列数据
const compareList = ref([])
const typeValue = ref(1)
//选择方式
const typechooser = [
  {
    label: '一键查新',
    value: 1
  },
  {
    label: '专业查新',
    value: 2
  },
  {
    label: '专业查新（备用）',
    value: 3
  },
  {
    label: 'incopat查新',
    value: 4
  }
]
// 是否显示对比方式
const isShowCompare = ref(true)
const arrowShow = ref(true)
const isFeatureSuccess = ref(false)
const activeStep = ref(0)
const activeShow = ref(true)
const selectable = (row) => ![1, 2].includes(row.id)
const tableData = ref([])
const selectedRows = ref([])
const retrieveLoading = ref(false)
const targetPatentJson = ref(null) // 新参数用于接收生成的JSON对象
const compareDialogVisible = ref(false)
const featureID = ref('')
const handleSelectionChange = (selection) => {
  selectedRows.value = selection;
  columns.value = [ { prop: 'id', label: '技术特征标识' }],
  compareList.value = []
  // 直接创建目标专利对象并生成feature属性
  const targetPatent = { id: '目标专利' };
  selection.forEach((row, index) => {
    targetPatent[`feature${index + 1}`] = row.feature || '';
    var arr ={ prop: `feature${index + 1}`, label: `技术特征${index + 1}` }
    columns.value.push(arr)
  });
  targetPatentJson.value = targetPatent;
  compareList.value.push(targetPatentJson.value)
  console.log('targetPatentJson',targetPatentJson.value)
}
const secondSelectedRows = ref([])
const handleSecondChange = (selection) => {
  secondSelectedRows.value = selection
}

  //特征内容修改
const handleEdit = (row) => {
  console.log(row)
  tableData.value.forEach(v => {
    console.log(v.id == row.id)
    if (v.id == row.id) {
      v.status = true
    } else {
      v.status = false
    }
  })
}
//特征内容删除
const handleFeatrueDelete = (id) => {
  tableData.value = tableData.value.filter(v => v.id !== id)
}
// 特征内容保存
const handleSave = (row) => {
  console.log(row)
  tableData.value.forEach(v => {
      v.status = false
  })
}
const featureTableRef = ref()
// 上一步
const backStep = () => {
  if(activeStep.value == 0){
    ElMessage.error('已在第一步')
    return
  }else if(activeStep.value == 1){
    activeStep.value = 0
  }else if(activeStep.value == 2){
    activeStep.value = 1
    compareList.value.splice(1)
  }

}

const handleAddFeature = () => {
  tableData.value.push({
    id: tableData.value.length + 1,
    index: tableData.value.length + 1,
    feature: '',
    status: true
  })
}
// 取消添加特征
const handleCancel = () => {
  tableData.value.forEach(v => {
      v.status = false
  })
}
const confirmComparePatents = () => {
  compareDialogVisible.value = false
  handleRetrievePatents(2)
}
const featureId = ref('')
const handleClick = (data) => {
  console.log(data)
  var url = ''
  if(typeValue.value == 2){
    featureId.value = data.PN
    console.log(featureId.value)
     url = `/feature?id=${featureId.value}`;
  }else{
    featureId.value = data.p
     url = `/pdf?id=${featureId.value}`;
  }

  window.open(url, '_blank');
}
// 根据所选特征进行专利检索
const handleRetrievePatents = async (type) => {
  retrieveLoading.value = true
  if(selectedRows.value.length == 0){
     ElMessage.error('请选择技术特征')
     retrieveLoading.value = false
    return
  }
  const features = selectedRows.value.map(v => v.feature)
  let sq = ''
   if(type == 2){
    sq = featureID.value
   }else{
    sq = `r/${features.join('+')+abstractStr.value}`
   }
   if(typeValue.value == 2){
      forwardInvokefun(sq,type)
   }else{
    let searchText = `${features.join(',')}`
     thirdInvokefun(searchText)
   }


}
//第二种方式
const forwardInvokefun = async (data,type) => {
  const requestData = {
    sf: "QueryFulltext",
    sx: "cn/queryfulltext_cn",
    sl: "chs",
    iclient: "1",
    sq: data,
    radiosd: "D", // 常数，固定值
    ips: 20, // 每页条数 支持 20,50,100
    ipi: 0, // 当前页
    sd: "D", // 常数，固定值
    idi: 4, // 数据库范围
    iopt: 5, // 常数，固定值
    ifig: 1, // 常数，固定值
    ibm: 1, // 常数，固定值
    iqf: 1, // 常数，固定值
    sdf: "p8t45a16i16c60l60r60" // 常数，固定值
  }
  const res = await forwardInvoke(requestData)
  console.log(res)
  if (res.statusCode === 200) {
    ElMessage.success('专利检索成功')
    activeStep.value = 1
    const comparePatent = JSON.parse(res.body).PatentList || []
    console.log(featureList.value)
    if(type == 0 ){
         featureList.value = comparePatent
      }else if(type == 1){
        featureList.value = featureList.value.concat(comparePatent)
      }else{
        featureList.value = comparePatent.concat(featureList.value)
      }
    console.log(featureList.value)
    featureList.value.forEach((v,index) => {
      v.index = index + 1
    })
  } else {
    ElMessage.error('专利检索失败')
  }
  retrieveLoading.value = false
}
//第三种方式
const thirdInvokefun = async (data) => {
  const requestData = {
    searchText: data
  }

  const SemanticsList = await fetchSemanticsSearch(requestData)
  console.log(JSON.parse(SemanticsList.body))
  let incoExp = ''
  var semanticsScoreList = []
  JSON.parse(SemanticsList.body).result.list.forEach(v => {
    incoExp +='PN='+ v.pn + ' OR '
    semanticsScoreList.push(v.semanticsScore)
  })
  incoExp = incoExp.slice(0, -4)
  console.log(incoExp)
  const requestData2 = {
    incoExp: incoExp
  }
  const res = await fetchIncopatSearch(requestData2)
  console.log(res)
  if (res.statusCode === 200) {
    ElMessage.success('专利检索成功')
    activeStep.value = 1
    const comparePatent = JSON.parse(res.body).result.rows || []
     console.log(JSON.parse(res.body).result.rows[0])
    console.log(JSON.parse(res.body).result.rows[0]['ti-cn'])
    var jsonList = []
    comparePatent.forEach(v => {
      var arr = {}
      arr.p = v.pn
      arr.t = v['ti-cn']
      arr.a = v['in-or']
      arr.ad = v.ad
      arr.r = ''
      arr.abstract = v['ab-cn']
      jsonList.push(arr)
    })
    semanticsScoreList.forEach((v,index) => {
        if (jsonList[index]) {
          jsonList[index].r = (v * 100).toFixed(2)
        }
      })
    featureList.value = featureList.value.concat(jsonList)
    console.log(featureList.value)
    featureList.value.forEach((v,index) => {
      v.index = index + 1
    })
  } else {
    ElMessage.error('专利检索失败')
  }
  retrieveLoading.value = false
}



const handleGenerate = async () =>{
  tableData.value =[]
  tableLoading.value = true
  ElMessage.info('正在重新生成特征...')
  try{
    const params = {
        solution:props.formData.technical,
        implementation: props.formData.implementation,
      }
    const featureResult = await featureExtraction(params)
    console.log(featureResult.result)
    isFeatureSuccess.value = true
    
    tableData.value = featureResult.result
    tableData.value.forEach((item,index) => {
      item.status = false
      item.index = index
    })
    ElMessage.success('特征提取成功')
  }catch(error){
    ElMessage.error('特征提取失败')
    tableLoading.value = false
  }finally{
    tableLoading.value = false
  }
}
const isLoading = ref(false)

const handleComparePatents = async () => {
  isLoading.value = true
  try {
    if(secondSelectedRows.value.length == 0){
      ElMessage.error('请选择专利进行对比')
      isLoading.value = false
      return
    }
    const compareFeatures = []
    for (const v of secondSelectedRows.value) {
      if(typeValue.value == 2){
        const Abstract = await handlePatentDetail(v.PN)
        console.log(Abstract)
        const comparePatent = {
          p: v.p,
          Abstract: Abstract
        }
        compareFeatures.push(comparePatent)
      }else{
        const comparePatent = {
          p: v.p,
          Abstract: v.abstract
        }
        compareFeatures.push(comparePatent)
      }


      }
    const features = []
    selectedRows.value.forEach(v => {
      features.push(v.feature)
    })
    const param = {
      compareFeatures: compareFeatures,
      features: features,
      abstractStr: abstractStr.value
    }
    const compareResult = await featureCompare(param)
    console.log(compareResult)
    if (compareResult) {
      const compareResultJson = compareResult.result
      compareList.value = [...compareList.value, ...compareResultJson.compareList]
      novelty.value = compareResultJson.novelty,
      creative.value = compareResultJson.creative
      conclusion.value = compareResultJson.conclusion
      ElMessage.success('对比成功')
    } else {
      ElMessage.error('对比失败')
    }
    activeStep.value = 2
  } finally {
   isLoading.value = false
  }
}
const handlePatentDetail = async (id) => {
  const data = {
    sf: 'ShowPatent',
    sx: 'showpatent_cn',
    sl: 'chs',
    spn: id
  }
  const featureInfo = await fetchPatentDetail(data)
  if(featureInfo.statusCode === 200){
    featureInfo.value = JSON.parse(featureInfo.body)
    console.log(featureInfo.value)
     console.log(featureInfo.value.Abstract)
    return featureInfo.value.Abstract;
  }else{
    ElMessage.error('获取专利详情失败')
    return null;
  }

}

const abstractTags = [
  { label: '背景技术', value: 'background' },
  { label: '技术问题', value: 'problem' },
  { label: '技术方案', value: 'technical' },
  { label: '有益效果', value: 'effect' },
  { label: '具体实施方式', value: 'implementation' },
  { label: '附图及简要说明', value: 'description' },
]
// 已选摘要标签
let selectedTags = ref(abstractTags.map(v => v.value))
const noveltySystemUrl = process.env.VUE_APP_NOVELTY_SYSTEM_URL

// 格式化分析文本
const formattedAnalysisText = computed(() => {
  if (analysisHtml.value) return analysisHtml.value
  if (!analysisText.value) return ''
  // 将文本中的换行转换为HTML
  return analysisText.value.replace(/\n/g, '<br>')
})

// 监听visible属性变化
watch(() => props.visible, (newVal) => {
  if (newVal) {
    isComparing.value = false
    uploadFileList.value = []
    noveltyFileList.value = [] // 清空查新生成的文件列表
    analysisText.value = ''
    analysisHtml.value = ''
    analysisResult = {}
    abstractStr.value = ''

  }
  dialogVisible.value = newVal
  getStatus()
  checkAuth()
})

// 监对话框状态变化
watch(dialogVisible, async (newVal) => {
  if (!newVal) {
    emit('update:visible', false)
    // 对话框关闭时停止循环
    stopStatusCheck();
  }
})

watch(() => props.formData, (newVal) => {
  analysisFormData.value = { ...newVal }
})

// 初始化PDF文档
const initPdf = async () => {
  try {
    const loadingTask = pdfjsLib.getDocument(pdfSource.value)
    pdfDocument.value = await loadingTask.promise
    currentPage.value = 1
    totalPages.value = pdfDocument.value.numPages
    console.log('PDF loaded with total pages:', totalPages.value)
  } catch (error) {
    console.error('Failed to load PDF:', error)
    ElMessage.error('PDF 加载失败')
  }
}
const status = ref(null)
const thirdPartyResponse = ref('')
// 存储状态检查定时器
const statusInterval = ref(null)

const getStatus = async () => {
  const statusString = await fetchStatus({
    projectId: props.projectId
  })

  if (statusString.task) {
    const oldStatus = status.value;
    status.value = statusString.task.status,
      abstractStr.value = statusString.task.requestParams
    thirdPartyResponse.value = statusString.task.thirdPartyResponse
    console.log(status.value === 'PROCESSING' && dialogVisible.value == true)
    // 根据状态决定是否继续循环
    if (status.value === 'PROCESSING' && dialogVisible.value == true) {
      // 只要状态为PROCESSING就启动循环检查，无论是否是首次进入
      startStatusCheck();
    } else {
      // 如果状态不是PROCESSING（包括失败状态），停止循环
      stopStatusCheck();

      // 特别处理失败状态，显示错误提示
      if (status.value === 'FAILED') {
        handlestop()
        ElMessage.error('查新报告生成失败，请稍后重试')
      }
    }
  } else {
    status.value = null
    // 状态为null时停止循环
    stopStatusCheck();
  }
}

// 启动状态检查循环（每5秒执行一次）
const startStatusCheck = () => {
  // 先清除已有的定时器，避免重复启动
  stopStatusCheck();

  // 设置5秒循环
  statusInterval.value = setInterval(() => {
    getStatus();
  }, 5000);
}

// 停止状态检查循环
const stopStatusCheck = () => {
  if (statusInterval.value) {
    clearInterval(statusInterval.value);
    statusInterval.value = null;
  }
}
const checkAuthCode = ref('0')
const checkAuth = async () => {
  const authResult = await fetchAuth({})
  console.log('authResult', authResult)
  if(authResult){
    checkAuthCode.value = authResult.isSuccess
  }
  console.log('checkAuthCode', checkAuthCode.value)
}
const handlequery = async () => {
  try {
    isQueryloading.value = true
    await fetchRecordAdd({
        projectId: props.projectId, 
        opType: "NOVELTY_COMPARE",
        stepName: '初版生成',
        stepCode: 'step3',
        blockCode: '',
        blockName: '',
        source: "ai",
        description: "查新比对",
        opDetail: '',
      })
    await convertDataToDocx(thirdPartyResponse.value)
    
  } catch (error) {
    console.error('Failed to convert data to docx:', error)
    ElMessage.error('查新对比失败')
  }
}
const handleDelete = async () => {
  try {
    ElMessageBox.confirm(
      '确定要清空当前查新报告吗？此操作不可恢复。',
      '确认清空',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(async () => {
      const deleteResponse = await fetchClear({ projectId: props.projectId })
      console.log(deleteResponse)
      if (deleteResponse.reportsDeleted) {
        ElMessage.success('清空查新成功')
        status.value = null
        abstractStr.value = ''
        thirdPartyResponse.value = ''
      }
    }).catch(() => {
      ElMessage.info('已取消清空操作')
    })
  } catch (error) {
    ElMessage.error('清空查新失败')
  }
}

const stopquery = async () => {
  try {
    ElMessageBox.confirm(
      '确定要停止当前查新任务吗？',
      '确认停止',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(async () => {
      handlestop()
    }).catch(() => {
      ElMessage.info('已取消停止操作')
    })
  } catch (error) {
    ElMessage.error('查新对比停止失败')
  }
}


const handlestop = async () => {
  const stopResponse = await fetchCancel({ projectId: props.projectId })
  console.log(stopResponse)
  if (stopResponse.cancelledCount === 1) {
    ElMessage.success('查新对比已停止')
    status.value = null
    abstractStr.value = ''
    thirdPartyResponse.value = ''
  }
}

const highlight = (text, target, options = {}) => {
  if (!text) return;
  const newOptions = {
    separateWordSearch: false,
    acrossElements: true,
    filter: (index, text) => {
      console.log(index, text)
      return true
    },
    ...options
  };
  const textReplace = text.replace(/\n/g, '');
  target.mark(textReplace, newOptions);
}

// 选择生成摘要标签
const handleSelectTag = (item) => {
  const selected = selectedTags.value.includes(item.value)
  if (selected) {
    selectedTags.value = selectedTags.value.filter(v => v !== item.value)
  } else {
    selectedTags.value.push(item.value)
  }
  console.log('selectedTags', selectedTags.value)
}

// 生成摘要
const handleAbstrace = async () => {
  const params = {}
  const keyMap = { technical: 'solution', description: 'drawings' }
  selectedTags.value.forEach((key) => {
    params[keyMap[key] || key] = props.formData[key]
  })

  abstractLoading.value = true
  try {
    const response = await fetch('/api/analysis/generate-summary', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify(params),
    })

    if (!response.ok) {
      throw new Error(`${field} 接口调用失败`)
    }

    // 处理流式响应
    let accumulatedContent = ''
    const reader = response.body.getReader()
    isStreaming.value = true

    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        isStreaming.value = false
        abstractLoading.value = false
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')
      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') continue
          try {
            const data = JSON.parse(jsonStr)
            console.log(data)
            if (data.result) {
              accumulatedContent += data.result
              await nextTick(() => {
                abstractStr.value = accumulatedContent
              })
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }
  } catch (error) {
    abstractLoading.value = false
  }
}

// 复制摘要
const handleCopyAbstrace = () => {
  Clipboard.copy(abstractStr.value)
  ElMessage.success('复制成功')
}

// 复制并跳转至查新系统
const handleGotoNovelty = () => {
  const username = process.env.VUE_APP_INCOPAT_USERNAME
  const checkcode = process.env.VUE_APP_INCOPAT_CHECKCODE
  const loginUrl = process.env.VUE_APP_NOVELTY_INCOPAT_SYSTEM_URL

  const randomcode = Math.floor(Math.random() * 1000000)
  const timestamp = new Date().getTime()
  const param = `${username}|${timestamp}|${randomcode}|${checkcode}`
  const signature = md5(param).toString()
  const transientQ = encodeURIComponent(abstractStr.value)

  const url = `${loginUrl}?username=${username}&randomcode=${randomcode}&timestamp=${timestamp}&signature=${signature}&transientQ=${transientQ}`

  console.log("url:", url)
  handleCopyAbstrace()
  window.open(url)
}
// const handleGotoNovelty = () => {
//   if (!abstractStr.value) {
//     ElMessage.warning('请先生成摘要内容')
//     return
//   }
//   const username = process.env.VUE_APP_INCOPAT_USERNAME
//   const checkcode = process.env.VUE_APP_INCOPAT_CHECKCODE
//   const loginUrl = process.env.VUE_APP_NOVELTY_INCOPAT_SYSTEM_URL

//   const randomcode = Math.floor(Math.random() * 1000000)
//   const timestamp = new Date().getTime()
//   const param = `${username}|${timestamp}|${randomcode}|${checkcode}`
//   const signature = md5(param).toString()
//   const transientQ = encodeURIComponent(abstractStr.value)

//   const url = `${loginUrl}?username=${username}&randomcode=${randomcode}&timestamp=${timestamp}&signature=${signature}&transientQ=${transientQ}`
//   console.log("url:", url)
//   handleCopyAbstrace()
//   window.open(url)
// }

// 生成带日期的文件名
const generateFileName = () => {
  // 硬编码为新颖性检索加上日期时间，格式为: 新颖性检索2025-07-13 16∶07∶27.docx
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')

  return `新颖性检索${year}-${month}-${day} ${hours}∶${minutes}∶${seconds}.docx`
}

// 登录查新系统外部接口
const loginMaxipatSystem = async () => {
  const requestBody = {
    userName: process.env.VUE_APP_NOVELTY_USERNAME,
    password: process.env.VUE_APP_NOVELTY_PASSWORD
  }
  try {
    // 调用服务器端代理接口，避免跨域问题
    const response = await fetch('/api/thirdPartyApi/externalAccesslogin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody),
    })
    console.log('登录查新系统响应:', response)

    // 检查HTTP状态码
    if (!response.ok) {
      throw new Error(`HTTP错误: ${response.status}`);
    }

    // 解析响应体为JSON
    const responseData = await response.json();
    console.log('登录查新系统结果数据:', responseData)

    // 检查业务返回码
    if (responseData.code !== 0) {
      throw new Error(`业务错误: ${responseData.message || '登录失败'}`);
    }

    const SearchesLatest = await thirdNoveltyWordReport(responseData.data.token)
    console.log('SearchesLatest', SearchesLatest)
  } catch (error) {
    console.error('登录查新系统失败:', error)
    ElMessage.error(`登录查新系统失败: ${error.message}`)
    return null
  }
}

// 将数据转换为docx文件的函数
const convertDataToDocx = async (data) => {
  
  data = JSON.parse(data)
  data.AbstractContentJson = JSON.parse(data.abstractContentJson || '[]')
  data.technologyJson = data.technologyFeatureJson.technologyFeatureJson || '[]'
  console.log(data)
  try {
    const response = await fetch('/api/docxReport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) throw new Error('文档生成失败');
    // 处理返回的文档流
    const fileName = generateFileName();
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    let file;
    try {
      // 创建File对象
      file = new File([blob], fileName, { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      // 调用handleNoveltyFileUpload函数上传文件进行分析
      await handleNoveltyFileUpload({ file });
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      // 清理URL对象
      window.URL.revokeObjectURL(url);
      ElMessage.success('查新报告已成功生成并上传进行分析');

    } catch (uploadError) {
      console.error('文件上传分析失败:', uploadError);
      ElMessage.error('查新报告生成成功，但上传分析失败');
    }

  } catch (error) {

    console.error('转换为Word文档失败:', error);
    ElMessage.error('转换为Word文档失败: ' + error.message);
  } finally {
    isQueryloading.value = false
  }
}


const thirdNoveltyWordReport = async (token) => {
  try {
    const response = await fetch('/api/thirdPartyApi/thirdNoveltyWordReport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,

      },
      timeout: 600000,
      body: JSON.stringify({
        contentQuery: abstractStr.value
      })
    })

    // 检查HTTP状态码
    if (!response.ok) {
      throw new Error(`HTTP错误: ${response.status}`);
    }

    // 解析响应体为JSON
    const responseData = await response.json();
    console.log('查新报告响应数据:', responseData)

    // 检查业务返回码
    if (responseData.code !== 0) {
      throw new Error(`业务错误: ${responseData.message || '查新报告生成失败'}`);
    }

    const mockResponse = responseData.data
    // 调用convertDataToDocx函数处理数据
    if (mockResponse) {
      await convertDataToDocx(mockResponse);
    }

    return mockResponse;
  } catch (error) {
    console.error('生成失败:', error);
    ElMessage.error(`生成失败: ${error.message}`);
    return null;
  }
}

//复制并查新
const handleNoveltys = async () => {
  isNoveltyLoading.value = true
  try {
    // 如果没有摘要内容，自动生成摘要
    if (!abstractStr.value) {
      ElMessage.info('正在为您生成摘要内容...')
      await handleAbstrace()
      // 等待摘要生成完成
      while (abstractLoading.value || isStreaming.value) {
        await new Promise(resolve => setTimeout(resolve, 100))
      }
      // 检查摘要是否生成成功
      if (!abstractStr.value) {
        ElMessage.warning('摘要生成失败，请重试')
        return
      }
    }
    if (typeValue.value == 1) {
      // 调用查新报告接口
      const reportResult = await fetchReport({
        projectId: props.projectId,
        contentQuery: abstractStr.value
      })
      if (reportResult) {
        ElMessage.success('生成报告中，大概需要4-5分钟')
        getStatus()
      }
    } else if (typeValue.value == 2 || typeValue.value == 3) {
      ElMessage.info('正在为您特征提取...')
      const params = {
        solution:props.formData.technical,
        implementation: props.formData.implementation,
      }
      const featureResult = await featureExtraction(params)
      console.log(featureResult.result)
      isFeatureSuccess.value = true
      tableData.value = featureResult.result
      tableData.value.forEach((item,index) => {
        item.status = false
        item.index = index
      })
      arrowShow.value = false
      ElMessage.success('特征提取成功')
    }else if(typeValue.value == 4) {
      handleGotoNovelty()
    }
      
  } finally {
    // 确保无论成功还是失败，都会关闭加载状态
    isNoveltyLoading.value = false
  }
}



// 上传查新生成的文件，逻辑与handleUploadFile类似但使用noveltyFileList
const handleNoveltyFileUpload = (options) => {
  const { file } = options
  console.log(file)
  if (file.size > 10 * 1024 * 1024) {
    ElMessage.warning(`文件 ${file.name} 超过10M限制`)
    return
  }
  if (!/\.(pdf|doc|docx)$/i.test(file.name)) {
    ElMessage.warning(`文件 ${file.name} 格式不支持`)
    return
  }

  // 使用新的变量保存文件信息，而不是uploadFileList
  noveltyFileList.value = [{ file, uid: file.uid || Date.now(), name: file.name, status: 'uploading' }]

  const formData = new FormData()
  formData.append('files', file)
  formData.append('fileType', 4)
  formData.append('projectId', props.projectId)

  return fetchUpload(formData).then((res) => {
    console.log('查新报告文件上传成功:', res)
    if (res) {
      noveltyFileList.value[0].status = 'done'
      noveltyFileList.value[0].path = res.fileUrl
      noveltyFileList.value[0].id = res.id
      ElMessage.success('查新报告已上传至服务器')
      console.log(1)
      // 上传成功后自动进行比对分析
      handleNoveltyComparing()
    } else {
      console.log(2)
      noveltyFileList.value = []
      ElMessage.warning(`文件上传失败`)
    }
  }).catch((err) => {
    console.log('文件上传错误:', err)
    noveltyFileList.value = []
    ElMessage.warning(`文件上传失败`)
  })
}


// 开始对比查新报告
const handleNoveltyComparing = async () => {
  analysisText.value = ''
  analysisHtml.value = ''
  analysisResult = {}

  const analysisFormData = new FormData()
  const fileInfo = noveltyFileList.value[0] // 使用noveltyFileList
  analysisFormData.append('file', fileInfo.file)
  // 使用父组件传递的表单数据
  analysisFormData.append('background', props.formData.background || '')
  analysisFormData.append('problem', props.formData.problem || '')
  analysisFormData.append('solution', props.formData.technical || '')  // 注意这里使用technical字段
  analysisFormData.append('effect', props.formData.effect || '')
  analysisFormData.append('implementation', props.formData.implementation || '')

  isAnalysisLoading.value = true

  let wordToPdfPath = ''
  if (/(\.doc|\.docx)$/i.test(fileInfo.name)) {
    const wordToPdfFormData = new FormData()
    wordToPdfFormData.append('file', fileInfo.file)

    const wordToPdfResponse = await fetch('/api/convert/word-to-pdf', {
      method: 'POST',
      body: wordToPdfFormData
    })

    const result = await wordToPdfResponse.json()

    if (result.content) {
      wordToPdfPath = result.content.pdfPath
      pdfSource.value = wordToPdfPath || fileInfo.path
    }
  } else {
    pdfSource.value = fileInfo.path
  }

  try {
    // 创建新的 AbortController
    abortController.value = new AbortController()
    autoScroll.value = true
    // 调用分析接口
    const analysisResponse = await fetch('/api/analysis/analysis', {
      method: 'POST',
      headers: {
        'Accept': 'text/event-stream'
      },
      body: analysisFormData,
      signal: abortController.value.signal
    })

    isAnalysisLoading.value = false
    isComparing.value = true
    analysisStreaming.value = true
    isFeatureSuccess.value = true
    initPdf()

    if (!analysisResponse.ok) {
      throw new Error(result.message || '分析失败')
    }

    const reader = analysisResponse.body.getReader()

    // 如果请求已经被取消，不更新
    if (abortController.value?.signal.aborted) {
      return
    }

    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        abortController.value = null
        handleSuggest(analysisText.value)
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') continue
          try {
            const data = JSON.parse(jsonStr)
            if (data.result) {
              analysisText.value += data.result
              const result = {
                filename: fileInfo.name,
                path: wordToPdfPath || fileInfo.path, // 优先使用转换后的PDF路径
                size: fileInfo.size,
                // 分析结果
                text_report: analysisText.value,
              }
              analysisResult = result
              handleScrollBottom()
            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }
    await fetchRecordAdd({
        projectId: props.projectId, 
        opType: "NOVELTY_COMPARE",
        stepName: '初版生成',
        stepCode: 'step3',
        blockCode: '',
        blockName: '',
        source: "ai",
        description: "查新比对",
        opDetail: '',
      })
  } catch (error) {
    console.error('分析失败:', error)
  } finally {
    autoScroll.value = false
    abortController.value = null
  }
}
// const url = `${loginUrl}?username=${username}&randomcode=${randomcode}&timestamp=${timestamp}&signature=${signature}&transientQ=${transientQ}`

// console.log("url:", url)
// handleCopyAbstrace()
// window.open(url)

const handleOperateProcess = () => {
  operateProcessRef.value.open()
}

// 上传文件
const handleUploadFile = (options) => {
  const { file } = options

  if (file.size > 10 * 1024 * 1024) {
    ElMessage.warning(`文件 ${file.name} 超过10M限制`)
    return
  }
  if (!/\.(pdf|doc|docx)$/i.test(file.name)) {
    ElMessage.warning(`文件 ${file.name} 格式不支持`)
    return
  }

  uploadFileList.value = [{ file, uid: file.uid, name: file.name, status: 'uploading' }]

  const formData = new FormData()
  formData.append('files', file)
  formData.append('fileType', 4)
  formData.append('projectId', props.projectId)

  fetchUpload(formData).then((res) => {
    console.log('res', res)
    if (res) {
      uploadFileList.value[0].status = 'done'
      uploadFileList.value[0].path = res.fileUrl
      uploadFileList.value[0].id = res.id
    } else {
      uploadFileList.value = []
      ElMessage.warning(`文件上传失败`)
    }
  }).catch((err) => {
    console.log('eee', err)
    uploadFileList.value = []
    ElMessage.warning(`文件上传失败`)
  })
}

// 删除文件
const handleRemoveFile = () => {
  fetchDeleteFile([uploadFileList.value[0].id]).then(res => {
    if (res) {
      uploadFileList.value = []
      ElMessage.success('文件删除成功')
    } else {
      ElMessage.warning('文件删除失败')
    }
  })
}

// 开始对比
const handleComparing = async () => {
  analysisText.value = ''
  analysisHtml.value = ''
  analysisResult = {}

  const analysisFormData = new FormData()
  const fileInfo = uploadFileList.value[0]
  analysisFormData.append('file', fileInfo.file)
  // 使用父组件传递的表单数据
  analysisFormData.append('background', props.formData.background || '')
  analysisFormData.append('problem', props.formData.problem || '')
  analysisFormData.append('solution', props.formData.technical || '')  // 注意这里使用technical字段
  analysisFormData.append('effect', props.formData.effect || '')
  analysisFormData.append('implementation', props.formData.implementation || '')

  isAnalysisLoading.value = true

  let wordToPdfPath = ''
  if (/\.(doc|docx)$/i.test(fileInfo.name)) {
    const wordToPdfFormData = new FormData()
    wordToPdfFormData.append('file', fileInfo.file)

    const wordToPdfResponse = await fetch('/api/convert/word-to-pdf', {
      method: 'POST',
      body: wordToPdfFormData
    })

    const result = await wordToPdfResponse.json()

    if (result.content) {
      wordToPdfPath = result.content.pdfPath
      pdfSource.value = wordToPdfPath || fileInfo.path
    }
  } else {
    pdfSource.value = fileInfo.path
  }

  try {
    // 创建新的 AbortController
    abortController.value = new AbortController()
    autoScroll.value = true
    // 调用分析接口
    const analysisResponse = await fetch('/api/analysis/analysis', {
      method: 'POST',
      headers: {
        'Accept': 'text/event-stream'
      },
      body: analysisFormData,
      signal: abortController.value.signal
    })

    isAnalysisLoading.value = false
    isComparing.value = true
    analysisStreaming.value = true
    isFeatureSuccess.value = true
    initPdf()

    if (!analysisResponse.ok) {
      throw new Error(result.message || '分析失败')
    }

    const reader = analysisResponse.body.getReader()

    // 如果请求已经被取消，不更新
    if (abortController.value?.signal.aborted) {
      return
    }

    while (true) {
      const { done, value } = await reader.read()
      if (done) {
        abortController.value = null
        handleSuggest(analysisText.value)
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      const lines = chunk.split('\n')

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          if (jsonStr === '[DONE]') continue
          try {
            const data = JSON.parse(jsonStr)
            if (data.result) {
              analysisText.value += data.result
              const result = {
                filename: fileInfo.name,
                path: wordToPdfPath || fileInfo.path, // 优先使用转换后的PDF路径
                size: fileInfo.size,
                // 分析结果
                text_report: analysisText.value,
              }
              analysisResult = result
              handleScrollBottom()

            }
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
          }
        }
      }
    }
  } catch (error) {
    console.error('分析失败:', error)
  } finally {
    autoScroll.value = false
    abortController.value = null
  }
}

// 获取对比标注
const handleSuggest = async (analysisText) => {
  try {
    const response = await fetch('/api/analysis/generate-suggestions', {
      method: 'POST',
      body: JSON.stringify({ analysisText })
    })

    if (!response.ok) {
      throw new Error('获取标注建议请求失败')
    }

    const data = await response.json()

    if (data.code === 0 && data.content) {
      analysisResult.structured_data = data.content
      if (data.content.formattedHtml) {
        analysisHtml.value = data.content.formattedHtml
      }
      // handleAnalysisResult()
    }
  } catch (error) {
    console.error('获取标注建议请求失败:', error)
  } finally {
    analysisStreaming.value = false
    ElMessage.success('分析完成')
  }
}

// 处理分析结果
const handleAnalysisResult = () => {
  nextTick(() => {
    const { background, effect, implementation, problem, solution } = analysisResult.structured_data.suggestions
    const suggest = new Mark(analysisTextRef.value)

    if (background) {
      highlight(background.suggestion, suggest, { className: 'markd1' })
    }
    if (problem) {
      highlight(problem.suggestion, suggest, { className: 'markd2' })
    }
    if (solution) {
      highlight(solution.suggestion, suggest, { className: 'markd3' })
    }
    if (effect) {
      highlight(effect.suggestion, suggest, { className: 'markd4' })
    }
    if (implementation) {
      highlight(implementation.suggestion, suggest, { className: 'markd5' })
    }
  })
}

// 根据分析结果进行修改
const handleInputAnalysis = (field, value) => {
  analysisFormData.value[field] = value
}

const handleBack = () => {
  if (abortController.value) {
    abortController.value.abort()
    abortController.value = null
  }
  isComparing.value = false
  isFeatureSuccess.value = false
  isComplianceSuccess.value = false
  arrowShow.value = true
  activeStep.value = 0
  analysisText.value = ''
  analysisHtml.value = ''
  analysisResult = {}
  analysisFormData.value = { ...props.formData }
}

const getHighlight = (key) => {
  const keyMap = { technical: 'solution' }
  const text = analysisResult?.structured_data?.suggestions?.[keyMap[key] || key]?.original_text
  return text ? [{ text }] : []
}

const handlePageRendered = () => {
  console.log('Current page rendered:', currentPage.value)
}

const handleLoading = (isLoading) => {
  console.log('PDF loading:', isLoading)
}

const handleError = (error) => {
  console.error('PDF error:', error)
  ElMessage.error('PDF 加载失败')
}

const handleUserSchool = (e) => {
  if (e.wheelDelta > 0) {
    // 向上滚动
    autoScroll.value = false
  } else {
    // 向下滚动
    const top = 80
    autoScroll.value = suggestRef.value.scrollTop + suggestRef.value.clientHeight + top >= suggestRef.value.scrollHeight
  }
}

const handleMouseDown = (e) => {
  if (e.offsetX + 8 >= 550) {
    autoScroll.value = false
  }
}

const handleScrollBottom = () => {
  if (!autoScroll.value) return
  if (suggestRef.value) {
    suggestRef.value.scrollTo({ top: suggestRef.value.scrollHeight, behavior: 'smooth' })
  }
}

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

// 处理关闭
const handleClose = () => {
  if (abortController.value) {
    abortController.value.abort()
    abortController.value = null
  }
  analysisFormData.value = { ...props.formData }
  dialogVisible.value = false
  emit('close')
}

// 保存修改
const handleSubmit = async () => {
  const { text_report, structured_data } = analysisResult
  await fetchSaveCompare({ projectId: props.projectId, value: JSON.stringify({ text_report, structured_data }) })
  emit('submit', analysisFormData.value)
  handleClose()
}

watch(() => isComparing.value, (newVal) => {
  if (newVal) {
    nextTick(() => {
      suggestRef.value.removeEventListener('wheel', handleUserSchool)
      suggestRef.value.addEventListener('wheel', handleUserSchool)
    })
  }
})
// 处理导出
const handleExport = async (type) => {
  const data ={}
  if(type==2){
    exportLoading.value = true
  }
  console.log(props.formData)
  data.topicQuery = props.formData.title
  data.contentQuery = props.formData.technical
  data.patentTotal = secondSelectedRows.value.length
  data.patentSelectTotal = secondSelectedRows.value.length
  data.abstractContentJson = secondSelectedRows.value
  data.novelty = novelty.value
  data.creative = creative.value
  data.conclusion = conclusion.value
  data.compareList = []
  const parsedCompareList = [];
  compareList.value.forEach(item => {
    parsedCompareList.push(Object.values(item));
  })
  data.compareList = parsedCompareList
  // generateDocx(data,type);
  var analysisCompareList = []
  data.compareList.forEach(item => {
    console.log(item)
    const jsonData = { name: item[0] || '' };
    // 最多处理到value3，不足则设为空值
    for (let i = 1; i <= 3; i++) {
      jsonData[`value${i}`] = item[i] !== undefined ? item[i] : '';
    }
    analysisCompareList.push(jsonData)
  })
  data.analysisCompareList = analysisCompareList;
  // 调用docx接口生成文档
  try {
    const response = await fetch('/api/docx', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) throw new Error('文档生成失败');
    // 处理返回的文档流
    const fileName = generateFileName();
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    
    if(type==1){
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      await fetchRecordAdd({
        projectId: props.projectId, 
        opType: "NOVELTY_REPORT",
        stepName: '初版生成',
        stepCode: 'step3',
        blockCode: '',
        blockName: '',
        source: "ai",
        description: "生成查新报告",
        opDetail: '',
      })
    }else{
     const file = new File([blob], fileName, { type: 'text/html' });
        handleNoveltyFileUpload({ file });
    }
  } catch (error) {
    console.error('调用docx接口失败:', error);
    // 可以添加错误提示逻辑
  }finally{
    exportLoading.value = false
  }

}

const handleTypeChange = (val) => {
    arrowShow.value = true
    isFeatureSuccess.value = false
    activeStep.value = 0
}
const cancel = () => {
    arrowShow.value = true
    isFeatureSuccess.value = false
    activeStep.value = 0
    retrieveLoading.value = false
}
const handleCloseDialog = () => {
    arrowShow.value = true
    isFeatureSuccess.value = false
    activeStep.value = 0
    retrieveLoading.value = false
}
</script>

<style lang="scss">
.analysis-dialog {
  height: calc(100vh - 60px) !important;
  border-radius: 24px 24px 0 0;

  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 30px;
    color: var(--el-text-color-regular);
    border-bottom: 1px solid #CDCDCD;

    .el-drawer__title {
      display: flex;
      gap: 8px;
      align-items: center;
      font-size: 18px;
      font-weight: 600;

      .el-icon {
        cursor: pointer;
      }
    }
  }

  .el-drawer__body {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
}
</style>
<style scoped lang="scss">
.analysis-content {
  display: flex;
  gap: 22px;
  flex: 1;
  padding-left: 9%;
  overflow: auto;

  :deep(.markd1),
  :deep(.markd2),
  :deep(.markd3),
  :deep(.markd4),
  :deep(.markd5),
  :deep(.analysis-text > span) {
    padding: 1px;
    border-radius: 4px;
  }

  :deep(.markd1),
  :deep(.analysis-text .background) {
    background: rgba(255, 0, 0, 0.15);
  }

  :deep(.markd2),
  :deep(.analysis-text .problem) {
    background: #FFE893;
  }

  :deep(.markd3),
  :deep(.analysis-text .solution) {
    background: #FBB4A5;
  }

  :deep(.markd4),
  :deep(.analysis-text .effect) {
    background: #FB9EC6;
  }

  :deep(.markd5),
  :deep(.analysis-text .implementation) {
    background: #FFCF9D;
  }
}

.selectshow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 30px;
}
 .novelty-tip {
      color: #999999;
      font-size: 10px;
      font-weight: 400;
      text-align: left;
    }

.analysis-footer {
  display: flex;
  justify-content: center;
  padding: 10px 0;
  border-top: 1px solid #E1E1E1;

  :deep(.el-button) {
    min-width: 250px;
  }
}

.middle-panel {
  width: 40px;
  display: flex;
  height: calc(100% - 32px);
  margin: 16px 0;
  padding: 16px;
  align-items: center;
  box-sizing: border-box;
}

.left-panel {
  flex: 2.7;
  display: flex;
  // flex-direction: column;
  flex-direction: row;
  gap: 33px;
  height: calc(100% - 32px);
  margin: 16px 0;
  padding: 16px;
  overflow: hidden;
  background: #F8F8F8;
  border-radius: 6px;
  box-sizing: border-box;
}

.left-process-panel {
  width: 38%;
  height: 100%;
  overflow: hidden;
  padding: 0;
  background: none;

  :deep(.card-title) {
    cursor: pointer;
  }
}

.process-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  .process-title {
    color: var(--el-color-primary);
    font-size: 16px;
    font-weight: 800;
  }

  .process-content {
    padding: 14px 20px;
    border: 1px solid #DDDDDD;
    border-radius: 6px;

    :deep(.el-textarea__inner) {
      height: 18.5vh !important;
      margin: 10px 0;
      padding: 0;
      resize: none;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .process-upload {
    :deep(.el-upload.is-disabled .el-upload-dragger) {
      cursor: default;
    }

    :deep(.el-upload-dragger) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 200px;
      height: calc(100vh - 60px - 580px);
      padding: 0;
      background: #fff;
      border-style: solid;
    }

    .process-upload-text {
      >h4 {
        margin-bottom: 8px;
        color: #222;
      }

      >div:nth-child(2) {
        margin-bottom: 20px;
        color: #999;
        font-size: 12px;
      }

      .process-upload-file {
        display: flex;
        align-items: center;
        gap: 10px;
        max-width: 300px;
        margin: 0 auto 8px;
        padding: 8px;
        color: #222;
        background: rgba(0, 161, 96, 0.06);
        border-radius: 6px;

        >span {
          flex: 1;
          text-align: left;
        }

        :deep(.el-loading-mask) {
          background: rgba(255, 255, 255, 0.3);

          .el-loading-spinner {
            margin-top: -15px;

            .circular {
              width: 30px;
              height: 30px;
            }
          }
        }

        .delete-icon {
          cursor: pointer;
        }
      }

      :deep(.el-button) {
        min-width: 140px;
        height: 36px;
        line-height: 36px;

        &.is-disabled {
          color: #555555;
          background: #EAEAEA;
          border-color: #EAEAEA;
        }
      }
    }
  }
}
.result-title{
  padding: 20px 0px;
}
.result-content{
  padding: 10px 20px;
  border: 1px solid #DDDDDD;
  border-radius: 6px;
}
.abstract-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 0;

  .abstract-tag-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    min-width: 102px;
    height: 36px;
    padding: 0 10px;
    list-style: none;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #333333;
    cursor: pointer;

    &.abstract-tag-selected {
      color: var(--el-color-primary);
      border-color: var(--el-color-primary);
      background: rgba(0, 161, 96, 0.06);
    }
  }
}

.abstract-actions {
  display: flex;
  align-items: center;
  gap: 16px;

  :deep(.el-button) {
    height: 36px;
    line-height: 36px;
    margin: 0;
    background: none !important;

    &:hover {
      color: var(--el-color-primary);
    }
  }

  .novelty-tip {
    color: #999999;
    font-size: 10px;
    font-weight: 400;
    text-align: left;
  }

  :deep(.el-icon) {
    font-size: 20px;
    cursor: pointer;

    &:hover {
      color: var(--el-color-primary);
    }
  }

  >span {
    flex: 1;
    text-align: right;
    color: #555;
  }
}

.right-panel {
  flex: 1.3;
  height: 100%;
  overflow-y: auto;
  padding-right: 9vw;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #E1E1E1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }
}

/* 表单区域样式 */
.form-section {}

.form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  border: 1px solid #E1E1E1;
  border-radius: 4px;

  label {
    display: flex;
    align-items: center;
    padding: 8px 22px;
    font-weight: 600;
    text-align: center;
    color: var(--el-text-color-regular);
  }

  textarea,
  input,
  .textarea {
    line-height: 20px;
    color: #444;
    font-family: PingFang SC;
    font-size: 14px;
    background: none;
    border: none;
    box-sizing: border-box;
  }

  textarea,
  .textarea {
    width: 100%;
    padding: 0 22px;
    min-height: 80px;
    resize: vertical;
  }

  .textarea {
    height: auto;
    padding-bottom: 8px;
    min-height: 30px;
    white-space: pre-wrap;
  }

  .textarea-wrapper {
    position: relative;

    :deep(.main) {
      box-sizing: border-box;
    }

    :deep(.highlight-input, .highlight-shadow-input) {
      min-height: 30px;
    }
  }

  .image-wrapper {
    padding: 12px 22px;
    border-top: 1px solid #E8E8E8;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .image-title {
      font-weight: bold;
    }
  }

  :deep(.el-image) {
    width: 160px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      border-color: var(--el-color-primary);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .el-image__inner {
      object-fit: contain;
      max-height: 100%;
    }

    .image-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #909399;
      font-size: 24px;
    }
  }

  &:has(.image-wrapper) {

    .textarea-wrapper textarea,
    .textarea-wrapper .textarea {
      padding-right: 160px; // 为图片留出空间
    }
  }
}

.form-row {
  display: flex;
  gap: 16px;
  transition: all 0.3s ease;

  .form-item {
    flex: 1;
    flex-direction: row;
    max-width: calc(50% - 12px);

    label {
      justify-content: center;
      width: 100px;
      padding: 0;
      border-right: 1px solid #E1E1E1;
    }

    input {
      width: 0;
      flex: 1;
      padding: 12px 14px;
      transition: all 0.3s ease;

      &:focus {
        outline: none;
        border-color: #1a1a1a;
        box-shadow: none;
      }
    }
  }
}

/* PDF 预览区域样式 */
.preview-section {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
}

.preview-section h3 {
  margin-bottom: 16px;
  font-size: 16px;
  text-align: center;
}

.pdf-container {
  position: relative;
}

.pdf-content {
  min-width: 472px;
  max-height: calc(100vh - 244px);
  width: 100%;
  margin: 0 auto;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  :deep(.vue-pdf-embed__page) {
    canvas {
      border-radius: 6px;
    }
  }
}

.pdf-navigation {
  :deep(.el-button) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:first-child {
      left: 6%;
    }

    &:last-child {
      right: 6%;
    }
  }
}

:deep(.vue-pdf-embed) {
  width: 100%;
  height: auto !important;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.vue-pdf-embed canvas) {
  max-width: 100%;
  height: auto !important;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-info {
  font-size: 14px;
  color: #64748B;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
}

/* 修改建议区域样式 */
.suggestions-section {
  flex: auto;
  max-width: 47.6%;
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  overflow: auto;
}

.suggestions-section h4 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 12px;
  color: #555;
}

.suggestion-content {
  color: #444;
}

.suggestion-header {
  margin-bottom: 10px;
}

.suggestion-content ol {
  padding-left: 20px;
}

.suggestion-content li {
  margin-bottom: 8px;
}

.form-item:last-child input {
  margin-right: 0;
}

.analysis-text {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #333;
}

@media screen and (max-width: 1600px) {
  .analysis-content {
    padding-left: 2%;
  }

  .right-panel {
    padding-right: 2vw;
  }
}
</style>
